import Vue from 'vue'
import Wapp from '@/wapp/wapp'

import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import ELEMENT from 'element-ui'

import '@/wapp/common/styles/element-variables.scss'
import '@/wapp/common/styles/index.scss' // global css

import { store, httpRequest } from 'ecinc-cloud-wappaio'
import { VueCropper } from '../../public/plugins/vue-cropper/src/index'
Vue.prototype.Cookies = Cookies
Vue.prototype.$http = httpRequest
Vue.use(VueCropper)
import wappUtils from '@/wapp/common/utils'
Vue.prototype.$wappUtils = wappUtils

import ecwappaio from 'ecinc-cloud-wappaio'
Vue.use(ecwappaio)

import i18n from '@/global/lang/index'

import router from '@/wapp/common/router'

import NewBusiForm from '@/wapp/workflow/BasicformOpen/newBusiForm'
Vue.component('NewBusiForm', NewBusiForm)
Vue.use(NewBusiForm)

Vue.use(require('ecinc-cloud-yoabase'))
Vue.use(require('ecinc-cloud-yoaecoa'))
Vue.use(require('ecinc-cloud-yoagwgl'))
Vue.use(require('ecinc-cloud-yoakqgl'))
Vue.use(require('ecinc-cloud-yoarsgl'))
Vue.use(require('ecinc-cloud-yoaxxfb'))
Vue.use(require('ecinc-cloud-yoazcgl'))
Vue.use(require('ecinc-cloud-yoaznbg'))

const moment = require('moment')
Vue.prototype.$moment = moment // 时间格式化 挂载在vue实例上 方便使用
const qs = require('qs')
Vue.prototype.$qs = qs
// 调用$getDefaultData获取小组件伪数据显示
import defaultApi from '@/wapp/common/utils/defaultApi.js'
Vue.prototype.$getDefaultData = ($scope, id) => {
    return defaultApi.getDefaultData($scope, id)
}

import '@/global/icons' // icon
import '@/wapp/common/router/beforeEach' // permission control
import '@/wapp/_import/vueLoader.js'
import '@/global/utils/validator.js'

import EVueContextmenu from 'e-vue-contextmenu'
Vue.use(EVueContextmenu)
// register global utility filters
import * as filters from '@/global/filters' // global filters
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

Vue.use(ELEMENT, {
    size: Cookies.get('size') || 'medium' // set element-ui default size
})

import '../../packages/developer'

// import DataTable from '@/wapp/DataTable/src/index'
// Vue.component('DataTable', DataTable)
// Vue.use(DataTable)

new Vue({
    el: '#wapp',
    router,
    store,
    i18n,
    render: (h) => h(Wapp)
})
